import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';
// import { Keyboard } from '@ionic-native/keyboard/ngx';

import { GlobalService } from '../global.service';
import { AjaxService } from '../ajax.service';

@Component({
    selector: 'app-afboeking2',
    templateUrl: './afboeking2.page.html',
    styleUrls: ['./afboeking2.page.scss'],
    standalone: false
})
export class Afboeking2Page implements OnInit {
    @ViewChild('scanInp', {static: false}) scanInp: ElementRef;

    gridHeight = 300;
    scanTxt = '';
    scanSbj: Subject<string> = new Subject();
    outBound = true;

    projnr = '';
    projtxt = 'Scan eerst een projectnummer';
    validProj = false;

    artnr = '';
    arttxt = '';
    artloc = '';
    artmut = 1;
    artmutOut = true;
    artvrd = 0;
    validArt = false;

    constructor(
        private router: Router,
        // private keyboard: Keyboard,
        public global: GlobalService,
        private ajax: AjaxService,
    ) { }

    ngOnInit() {
    }

    ionViewWillEnter() {
        this.onResize();
        this.processScan(localStorage.getItem('lastProjNr'));
        this.scanInp.nativeElement.focus();
    }

    onResize() {
        this.gridHeight = (window.innerHeight - 60) / 3;
    }

    onFocus() {
        // this.keyboard.hide();
    }

    onKeydown(event) {
        if (event.key === 'Enter' || event.key === 'Tab') {
            this.processScan(this.scanTxt);
            this.prepareNextScan();
        }
    }

    toggleOutbound() {
        this.outBound = !this.outBound;
        this.prepareNextScan();
    }

    /**
     * Er is een code ingevoerd
     * @param scantxt ingevoerde tekst
     */
    processScan(scantxt) {
        this.ajax.get('processScan', { req: scantxt, out: this.outBound, proj: this.projnr })
        .then((data: any) => {
            if (!data.login) {
                this.router.navigateByUrl('login');
            } else {
                if (data.hasOwnProperty('ord')) {
                    this.projnr = data.ord.nr;
                    this.projtxt = data.ord.des;
                    this.validProj = true;
                    localStorage.setItem('lastProjNr', this.projnr);
                    this.prepareNextScan();
                } else if (data.hasOwnProperty('art') && this.validProj) {
                    if (this.artnr === data.art.nr) {
                        // zelfde scan als vorige keer
                        if (this.artmutOut === this.outBound) {
                            this.artmut++;
                        } else {
                            this.artmut--;
                        } // 1001
                    } else {
                        // nieuw artikel scan
                        this.artnr = data.art.nr;
                        this.arttxt = data.art.des;
                        this.artloc = data.art.loc;
                        this.artmut = 1;
                        this.artmutOut = this.outBound;
                    }
                    this.artvrd = data.art.vrd;
                    this.validArt = true;
                }
            }
        });
    }

    prepareNextScan() {
        this.scanTxt = '';
        this.scanInp.nativeElement.focus();
    }
}
